// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"decd488a","198":"d91b902e"}[chunkId] + ".chunk.js";
};